import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../Accessor.js";
import e from "../Collection.js";
import { isNone as n, isSome as o } from "../maybe.js";
import { getProperties as r } from "./utils.js";
var f = ["esri.Color", "esri.portal.Portal", "esri.symbols.support.Symbol3DAnchorPosition2D", "esri.symbols.support.Symbol3DAnchorPosition3D"];

function i(e) {
  return e instanceof t;
}

function c(t) {
  return t instanceof e ? Object.keys(t.items) : i(t) ? r(t).keys() : t ? Object.keys(t) : [];
}

function u(t, n) {
  return t instanceof e ? t.items[n] : t[n];
}

function l(t, e) {
  return !(!Array.isArray(t) || !Array.isArray(e)) && t.length !== e.length;
}

function s(t) {
  return t ? t.declaredClass : null;
}

function p(t, e) {
  var n = t.diff;
  if (n && "function" == typeof n) return n(t, e);
  var r = c(t),
      a = c(e);
  if (0 === r.length && 0 === a.length) return;
  if (!r.length || !a.length || l(t, e)) return {
    type: "complete",
    oldValue: t,
    newValue: e
  };
  var y = a.filter(function (t) {
    return -1 === r.indexOf(t);
  }),
      m = r.filter(function (t) {
    return -1 === a.indexOf(t);
  }),
      d = r.filter(function (n) {
    return a.indexOf(n) > -1 && u(t, n) !== u(e, n);
  }).concat(y, m).sort(),
      b = s(t);
  if (b && f.indexOf(b) > -1 && d.length) return {
    type: "complete",
    oldValue: t,
    newValue: e
  };
  var h;
  var j = i(t) && i(e);

  var _iterator = _createForOfIteratorHelper(d),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _f = _step.value;

      var _r = u(t, _f),
          _i = u(e, _f);

      var _c = void 0;

      (j || "function" != typeof _r && "function" != typeof _i) && _r !== _i && (null == _r && null == _i || (_c = n && n[_f] && "function" == typeof n[_f] ? n[_f](_r, _i) : "object" == typeof _r && "object" == typeof _i && s(_r) === s(_i) ? p(_r, _i) : {
        type: "complete",
        oldValue: _r,
        newValue: _i
      }, o(_c) && (o(h) ? h.diff[_f] = _c : h = {
        type: "partial",
        diff: _defineProperty({}, _f, _c)
      })));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return h;
}

function a(t, e) {
  if (n(t)) return !1;
  var o = e.split(".");
  var r = t;

  var _iterator2 = _createForOfIteratorHelper(o),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _n = _step2.value;
      if ("complete" === r.type) return !0;
      if ("partial" !== r.type) return !1;
      {
        var _t = r.diff[_n];
        if (!_t) return !1;
        r = _t;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return !0;
}

function y(t, e) {
  var _iterator3 = _createForOfIteratorHelper(e),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _n2 = _step3.value;
      if (a(t, _n2)) return !0;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return !1;
}

function m(t, e) {
  if (!("function" == typeof t || "function" == typeof e || n(t) && n(e))) return n(t) || n(e) || "object" == typeof t && "object" == typeof e && s(t) !== s(e) ? {
    type: "complete",
    oldValue: t,
    newValue: e
  } : p(t, e);
}

function d(t) {
  if (n(t)) return !0;

  switch (t.type) {
    case "complete":
      return !1;

    case "collection":
      {
        var _e = t;

        var _iterator4 = _createForOfIteratorHelper(_e.added),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t2 = _step4.value;
            if (!d(_t2)) return !1;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        var _iterator5 = _createForOfIteratorHelper(_e.removed),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t3 = _step5.value;
            if (!d(_t3)) return !1;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        var _iterator6 = _createForOfIteratorHelper(_e.changed),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _t4 = _step6.value;
            if (!d(_t4)) return !1;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return !0;
      }

    case "partial":
      for (var _e2 in t.diff) {
        if (!d(t.diff[_e2])) return !1;
      }

      return !0;
  }
}

export { m as diff, a as hasDiff, y as hasDiffAny, d as isEmpty };